// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { Vue, store, i18n, LocaleMixin } from '@/locale_watcher'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import './assets/styles/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import defaultData from '@/about'
import bzConfig from '@/bz-config'

Vue.use(BootstrapVue)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  mixins: [LocaleMixin],
  i18n,
  created: function () {
    store.dispatch('bzTree/configure', bzConfig)
    store.dispatch('bzTree/loadData', defaultData)
  }
})



// WEBPACK FOOTER //
// ./src/main.js